/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/range_intersects.json`.

import type { FunctionDefinition } from '../../definition_types';

/**
 * Returns true if the two arguments overlap. The relation is symmetric — argument order does not matter. Supports all combinations of ranges and corresponding scalar types. When both arguments are scalar values, this is equivalent to `a == b`.
 *
 * @example
 * FROM employees
 * | WHERE RANGE_INTERSECTS(hire_date, TO_DATE_RANGE("1985-02-01..1985-03-01"))
 * | KEEP emp_no, hire_date
 * | SORT emp_no
 */
const definition: FunctionDefinition = {
  type: 'scalar',
  name: 'range_intersects',
  signatures: [
    {
      params: [
        {
          name: 'left',
          type: 'date',
          optional: false,
        },
        {
          name: 'right',
          type: 'date',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'boolean',
    },
    {
      params: [
        {
          name: 'left',
          type: 'date',
          optional: false,
        },
        {
          name: 'right',
          type: 'date_range',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'boolean',
    },
    {
      params: [
        {
          name: 'left',
          type: 'date_range',
          optional: false,
        },
        {
          name: 'right',
          type: 'date',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'boolean',
    },
    {
      params: [
        {
          name: 'left',
          type: 'date_range',
          optional: false,
        },
        {
          name: 'right',
          type: 'date_range',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'boolean',
    },
    {
      params: [
        {
          name: 'left',
          type: 'double',
          optional: false,
        },
        {
          name: 'right',
          type: 'double',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'boolean',
    },
    {
      params: [
        {
          name: 'left',
          type: 'double',
          optional: false,
        },
        {
          name: 'right',
          type: 'double_range',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'boolean',
    },
    {
      params: [
        {
          name: 'left',
          type: 'double_range',
          optional: false,
        },
        {
          name: 'right',
          type: 'double',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'boolean',
    },
    {
      params: [
        {
          name: 'left',
          type: 'double_range',
          optional: false,
        },
        {
          name: 'right',
          type: 'double_range',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'boolean',
    },
  ],
  preview: true,
  snapshotOnly: false,
};

export default definition;
